import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import scrollToComponent from 'react-scroll-to-component';
import { CookiesProvider } from 'react-cookie'
import Test from '../test/test'
import 'intersection-observer'; // optional polyfill
import Observer from '@researchgate/react-intersection-observer';
import PropTypes from "prop-types";
import {selectItem} from "../../actions";
import Youtube from "../../components/youtube-embed/youtube-embed";
import Scroll from "../../components/scroll/scroll";
import Slider from './slider'
import ScrollPercentage from '../../components/scroll-percentage/scroll-percentage'
import { sendEvent, pageView } from '../../helpers/analytics'
import queryString from '../../helpers/query-string';
import Fade from 'react-reveal/Fade';

import './home.critical.css'
import './home.css'
import InfoGraphic from "../infographic/infographic";

const fadeOptions = { duration: 600, fraction: 0.3};

const instructors = 'https://www.porsche-russland.ru/pdc/about/team/?utm_source=Rambler&utm_medium=SP&utm_content=Instructors&utm_campaign=Porsche_Sport_Challenge'
const introduction = 'https://www.porsche-russland.ru/pdc/intro/index.phtml?utm_source=Rambler&utm_medium=SP&utm_content=Introduction&utm_campaign=Porsche_Sport_Challenge'
const precision = 'https://www.porsche-russland.ru/pdc/Precision/index.phtml?utm_source=Rambler&utm_medium=SP&utm_content=Precision&utm_campaign=Porsche_Sport_Challenge'
const performance = 'https://www.porsche-russland.ru/pdc/Performance/index.phtml?utm_source=Rambler&utm_medium=SP&utm_content=Perfomance&utm_campaign=Porsche_Sport_Challenge'
const master = 'https://www.porsche-russland.ru/pdc/Master/index.phtml?utm_source=Rambler&utm_medium=SP&utm_content=Master&utm_campaign=Porsche_Sport_Challenge'

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      prevent: true,
      loaded: false
    }
    this.sections = []
  }

  componentDidUpdate (prevProps) {
    if (prevProps.currentItem !== this.props.currentItem && this.props.scroll) {
      this.scrollToSection(this.props.currentItem);
    }
  }

  componentDidMount () {
    pageView('/')

    const hash = queryString.parse(window.location.search)
    if (hash.token) {
      window.scrollTo(0, this.sections[11].offsetTop)
      this.props.onScrollInViewport(11)
      this.props.history.push({
        pathname: '/',
        search: ''
      })

    } else {
      this.scrollToSection(this.props.currentItem)
    }
    this.setState({loaded: true})
  }

  section0ref = (node) => {this.sections[0] = node}
  section1ref = (node) => {this.sections[1] = node}
  section2ref = (node) => {this.sections[2] = node}
  section3ref = (node) => {this.sections[3] = node}
  section4ref = (node) => {this.sections[4] = node}
  section5ref = (node) => {this.sections[5] = node}
  section6ref = (node) => {this.sections[6] = node}
  section7ref = (node) => {this.sections[7] = node}
  section8ref = (node) => {this.sections[8] = node}
  section9ref = (node) => {this.sections[9] = node}
  section10ref = (node) => {this.sections[10] = node}
  section11ref = (node) => {this.sections[11] = node}
  section12ref = (node) => {this.sections[12] = node}
  section13ref = (node) => {this.sections[13] = node}
  longreadRef = (node) => {this.longread = node}

  handleIntersection = (event) => {
    if (!this.props.scroll) {

      const id = parseInt(event.target.dataset.id, 10);
      const forceScroll = event.target.dataset.scroll;

      const {scrollDirection} = this.state

      if (forceScroll === 'true') {
        if (scrollDirection === 'down' && event.intersectionRatio < 0.25 && this.props.currentItem !== id && this.props.currentItem < id) {
          this.scrollToSection(id)
          this.props.onScrollInViewport(id)
          if (id === 13) {
            sendEvent('infographic', 'load', 'infographic screen')
          }
        }

      }

      if (event.isIntersecting && event.intersectionRatio > 0.25) {
        if (id !== this.props.currentItem) {
          this.props.onScrollInViewport(id)
        }
      }
    }

  }

  scrollToSection = (i) => {
    const hash = queryString.parse(window.location.search)

    if (hash.length) return true

    const currentSection = this.sections[i]
    scrollToComponent(currentSection, {duration: 600, align: 'top'})

  }

  handleWheel = (e) => {
    let { currentItem } = this.props;

    if (e.direction === 'down') {
      if (currentItem === 1) {
        scrollToComponent(this.longread, {duration: 600, align: 'top'})
        this.setState({prevent: false})
      } else {
        let nextItem = currentItem + 1
        this.props.onScrollInViewport(nextItem)
        this.scrollToSection(nextItem)
      }
    }

    if (e.direction === 'up' && currentItem > 0) {
      let nextItem = currentItem - 1
      this.props.onScrollInViewport(nextItem)
      this.scrollToSection(nextItem)
      this.setState({prevent: true})
    }

  }

  sendLinkevent = () => {
    sendEvent('main', 'click', 'link')
  }

  checkDirection = (e) => {
    const { scroll, onScrollInViewport, currentItem } = this.props;
    if (scroll) onScrollInViewport(currentItem)
    this.setState({scrollDirection: e.direction})
  }

  render () {
    const options = {
      onChange: this.handleIntersection,
      threshold: [0, 0.01, 0.25, 0.5, 0.75, 1],
      rootMargin: '-20px'
    };

    const optionsInterview = {
      onChange: (e) => {this.handleIntersection(e); sendEvent('interview1', 'load', 'first-screen') },
      threshold: [0, 0.01, 0.25, 0.5, 0.75, 1],
      rootMargin: '-20px'
    };

    let firstSectionClass = "full_height_section section--enter"
    if (this.props.currentItem === 0 && this.state.loaded) firstSectionClass += ' section--current'

    return (
      <div className="section__column">
        <Scroll preventMouse={false} scroll={(e) => this.checkDirection(e)}>
          <ScrollPercentage category={"longread"} type={"long"}>

            <Scroll preventMouse={this.state.prevent} scroll={(e) => this.handleWheel(e)}>
              <Observer {...options}>
                <section className={firstSectionClass}
                         ref={this.section0ref}
                         data-id="0"
                >
                    <div className="section__content">
                      <img src="/images/logo70@3x.png" alt="70 лет" className="logo__70" />
                      <h2 className="section__title --big">лучшее время</h2>
                    </div>

                    <div className="section__text text-center">Porsche — одна из самых <br />титулованных марок в автоспорте. <br />Объясняем и напоминаем, почему.</div>
                    <button className="arrow_down" onClick={() => { this.scrollToSection(1); sendEvent('main', 'click', 'arrow') }} />
                </section>
              </Observer>
            </Scroll>

            <Scroll preventMouse={this.state.prevent} scroll={(e) => this.handleWheel(e)}>

              <Observer {...options}>
                <div ref={this.section1ref}
                     data-id="1"
                >
                  <section className="full_height_section section--height" onWheel={(e) => this.handleWheel(e)}>
                    <div className="section">
                      <div className="section__row --between">
                        <h2 className="section__title">70 лет <br />на высоте</h2>
                        <img src="/images/logo70@3x.png" alt="70 лет" className="logo__70" />
                      </div>
                      <div className="section__text --left">Первый автомобиль под именем Porsche был зарегистрирован 8 июня 1948 года - это был 356 “No.1” Roadster. Именно этот день и считается днем рождения Porsche, который в этом году отмечается по всему миру. Узнайте о победах и успехах бренда, а также посмотрите, как прошел первый международный Sportscar Together Day!</div>
                      <button className="arrow_down" onClick={() => { scrollToComponent(this.longread, {duration: 500, align: 'top'}); sendEvent('main', 'click', 'arrow')}}  />
                    </div>
                  </section>
                </div>
              </Observer>
            </Scroll>

            <Observer  {...options}>
              <div data-id="2">
                <section className="longread" ref={this.longreadRef}>
                  <div className="longread__section">
                    <Fade {...fadeOptions} >
                      <img src="/images/long1.jpg" alt="porsche" className="longread__fullwidth" />
                    </Fade>
                  </div>
                </section>
              </div>
            </Observer>

            <Observer  {...options}>
              <div data-id="2">
                <section className="longread">
                  <div className="longread__section">
                    <div className="article">
                      <h1 className="article__title">70 лет <br className="--mobile" />на высоте</h1>
                      <div className="article__row">
                        <div className="article__col article__text">
                          <p>Porsche — это синоним изящного стиля и безупречного качества. Это технологические инновации и постоянное стремление к совершенству.</p>
                          <p>А еще Porsche — очень титулованный бренд в автоспорте: 70 лет истории побед в гонках на выносливость и «Формуле-1», в классическом ралли и экстремальных ралли-рейдах. Гонки — неотъемлемая часть ДНК Porsche и отличный способ проверить технику на пределе возможностей. И сейчас Porsche является одним из крупнейших производителей гоночных автомобилей в мире. Потому что гонки — это Porsche, а Porsche — это гонки.</p>
                        </div>
                        <div className="article__col article__image">
                          <Youtube link={"https://www.youtube.com/embed/ZiDaZ7h-sbQ"} />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </Observer>

            <Observer {...options}>
              <section className="longread" ref={this.section3ref} data-id="3">
                <div className="longread__section">
                  <div className="article">
                    <h2 className="article__subtitle">начало пути</h2>
                    <div className="article__row">
                      <div className="article__col article__text">
                        <p>История Porsche неразрывно связана с историей автоспорта и начинается с триумфа Аугуста Вёлле и Эдмонда Муше в марафоне «24 часа Ле-Мана» 1951 года. Это был первый старт Porsche 356 SL Coupe в легендарной гонке, и французские гонщики финишировали на 19-м месте абсолютного зачёта и одержали победу в классе S1.1, опередив ближайших соперников на четыре круга. Кроме того, этот Porsche проехал гонку с рекордной средней скоростью. Три года спустя появление 550 Spyder ознаменовало собой третье место в гонке Carrera Panamericana — 3000-километровом марафоне в Мексике.</p>
                      </div>
                      <div className="article__col article__text">
                        <Fade {...fadeOptions} >
                          <img src="/images/article1.png" alt="начало пути" />
                        </Fade>
                      </div>
                    </div>

                    <div className="article__row">
                      <div className="article__col --mobile-second article__text">
                        <Fade {...fadeOptions}>
                          <img src="/images/article2.png" alt="начало пути" />
                        </Fade>
                      </div>
                      <div className="article__col  article__text">
                        <p> Несмотря на проблемы с шинами в самом начале заезда, Ганс Геррманн сумел отыграть потерянное время и вырваться на третье место абсолютного зачёта и победить в классе S1.5, опередив при этом множество соперников с двигателями большего объёма и мощности. Свою первую большую победу автомобили Porsche одержали в 1956 году, когда Умберто Мальоли в экипаже с Хушке фон Ханштейном выиграли Targa Florio — знаменитый марафон на Сицилии. Это произошло всего через восемь лет после создания первого автомобиля под маркой Porsche. Но автоспортивная история Porsche только начиналась…</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </Observer>

            <Observer {...options}>
              <section className="longread" ref={this.section4ref} data-id="4">
                <div className="longread__section">
                  <div className="article">
                    <h2 className="article__subtitle">Первое покорение <span style={{whiteSpace: 'nowrap'}}>Ле-Мана</span></h2>

                    <div className="article__row">
                      <div className="article__col article__text">
                        Новая глава гоночной истории Porsche началась в конце 60-х, когда Ганс Мецгер начал работу над спортпрототипом модели 917. Инженерам удалось добиться от автомобиля невероятной стабильности — гонщики отмечали, что на прямых могли отпустить руль, и машина всё равно держала бы траекторию. А 4,5-литровый двигатель позволял развивать скорость на 30 км/ч выше конкурентов. И в 1970 году именно этот автомобиль принёс Porsche первую победу в Ле-Мане в абсолютном зачёте. Более того, в том году экипажи Porsche оккупировали весь подиум, заняв первое, второе и третье места.
                      </div>
                      <div className="article__col article__text">
                        <Fade {...fadeOptions}>
                          <img src="/images/article3.png" alt="Первое покорение" />
                        </Fade>
                      </div>
                    </div>

                    <div className="article__row">
                      <div className="article__col --mobile-second article__image">
                        <Fade {...fadeOptions}>
                          <img src="/images/video2.jpg" alt=""/>
                        </Fade>
                      </div>
                      <div className="article__col article__text">
                        <p className="--last">Так началась одна из наиболее успешных серий в истории спорта — в 1971-м Porsche 917K одержал вторую победу подряд, а в 1976 и 1977 годах на Porsche 936 дважды «24 часа Ле-Мана» выиграл Жаки Икс. Ещё один успех ждал марку в 1979-м, а в 80-х соперников у Porsche уже не осталось: семь лет подряд — с 1981 по 1987 годы — в Ле-Мане неизменно побеждала команда Porsche.</p>
                        <p className="--desktop">Эти успехи закрепили за Porsche статус культовой марки, а выход фильма «Ле-Ман», в котором Стив Маккуин ездил на 917-й, и вовсе сделал эту машину одним из самых узнаваемых гоночных автомобилей в мире.</p>
                      </div>
                      <div className="article__col --mobile --last article__text">
                        <p>Эти успехи закрепили за Porsche статус культовой марки, а выход фильма «Ле-Ман», в котором Стив Маккуин ездил на 917-й, и вовсе сделал эту машину одним из самых узнаваемых гоночных автомобилей в мире.</p>
                      </div>
                    </div>
                  </div>

                  <div className="longread__image">
                    <Fade {...fadeOptions}>
                      <img src="/images/long2.jpg" alt="porsche" className="longread__fullwidth" />
                    </Fade>
                  </div>

                </div>
              </section>
            </Observer>

            <Observer {...options}>
              <section className="longread" ref={this.section5ref} data-id="5">
                <div className="longread__section">
                  <div className="article">

                    <h2 className="article__subtitle">Теперь <br className="--mobile" />и Формула-1!</h2>

                    <div className="article__row">
                      <div className="article__col article__text">
                        В 80-х годах Porsche удалось покорить главную вершину в автоспорте - выиграть чемпионат Формулы-1. Для этого немецкая марка объединилась с легендарной командой McLaren и построила совершенно новый двигатель. В моторе использовались лучшие разработки инженеров Porsche, но для компактного шасси McLaren и предельно малого отсека под мотор силовую установку пришлось полностью переделывать. Однако уже в пятой гонке McLaren с двигателем Porsche одерживает победу — Ален Прост выиграл Гран-при Бразилии 1984 года, а уже на следующей гонке — Гран-при ЮАР - первенствовал Ники Лауда.
                      </div>
                      <div className="article__col article__image">
                        <Fade {...fadeOptions}>
                          <img src="/images/article4.jpg" alt="начало пути" />
                        </Fade>
                      </div>
                    </div>

                    <div className="article__row">
                      <div className="article__col --mobile-second  article__image">
                        <Fade {...fadeOptions}>
                          <img src="/images/article5.jpg" alt="начало пути" />
                        </Fade>
                      </div>
                      <div className="article__col article__text">
                        В общей сложности в том году пилоты McLaren одержали 12 побед, Лауда и Прост заняли по итогам чемпионата первое и второе место, а команда с огромным отрывом завоевала Кубок конструкторов. Победная поступь продолжилась и в следующем году — шесть побед, титул чемпиона для Алена Проста и второй подряд Кубок конструкторов. Наконец, в 1986 году Прост вновь стал чемпионом. Таким образом, на счету Porsche пять чемпионских титулов и 25 побед в гонках Формулы-1 - и по этому показателю немецкая марка входит в десятку наиболее успешных поставщиков двигателей в истории чемпионата.
                      </div>
                    </div>

                  </div>
                </div>
              </section>
            </Observer>

            <Observer {...options}>
              <section className={this.props.currentItem === 6 ? "longread --current" : "longread"} ref={this.section6ref} data-id="6">
                <div className="longread__section">
                  <div className="article">
                    <h2 className="article__subtitle">Возвращение <br className="--mobile" />на вершину</h2>
                    <div className="article__row">
                      <div className="article__col article__text">
                        <p>В XXI веке Porsche триумфально вернулся в Ле-Ман. Симбиоз максимальных скоростей и новейших гибридных технологий стали тем вызовом, который привлёк инженеров Porsche и заставил придумать новый спортпрототип — 919-ю модель. Porsche 919 впервые приехал на «24 часа Ле-Мана» в 2014 году, а уже <span className="--mobile-inline">в 2015-м Ник Тэнди, Эрл Бамбер и гонщик Формулы-1 Нико Хюлькенберг одержали на нём победу. В 2016-м ещё одну победу Porsche принесли Ромен Дюма, Нил Яни и Марк Либ, а в 2017-м их успех повторили Тимо Бернхард, Брендон Хартли и Эрл Бамбер, записавший на свой счёт второй триумф в суточном марафоне. В 2018 году Porsche вновь среди лучших в Ле-Мане: подиум в классе GT был полностью занят пилотами 911 RSR.</span>
                        </p>
                      </div>
                      <div className="article__col article__text --desktop">
                        <p>в 2015-м Ник Тэнди, Эрл Бамбер и гонщик Формулы-1 Нико Хюлькенберг одержали на нём победу. В 2016-м ещё одну победу Porsche принесли Ромен Дюма, Нил Яни и Марк Либ, а в 2017-м их успех повторили Тимо Бернхард, Брендон Хартли и Эрл Бамбер, записавший на свой счёт второй триумф в суточном марафоне. В 2018 году Porsche вновь среди лучших в Ле-Мане: подиум в классе GT был полностью занят пилотами 911 RSR.</p>
                      </div>
                    </div>
                  </div>

                  <div className="longread__image">
                    <Fade {...fadeOptions}>
                      <img src="/images/long3_light.jpg" alt="porsche" className="longread__fullwidth" />
                      <img src="/images/long3_dark.jpg" alt="porsche" className="longread__fullwidth --dark" />
                    </Fade>
                  </div>

                  <div className="article">
                    <div className="article__row">
                      <div className="article__col article__text">
                        <p>В общей сложности машины Porsche побеждали в Ле-Мане 20 раз — и это абсолютный рекорд самого престижного марафона в мире. Кроме того, Porsche принадлежит рекорд по числу побед подряд — больше никому не удавалось побеждать в «24 часах Ле-Мана» семь раз подряд. Теперь компания Porsche приняла новый вызов — в 2019 году немецкая марка дебютирует в Формуле-Е, новейшем первенстве машин с открытыми колёсами на электрической тяге. Гонки электромобилей — одно из наиболее перспективных направлений в автоспорте, а также возможность протестировать различные решения прежде чем внедрить их в дорожные автомобили Porsche. </p>
                      </div>
                      <div className="article__col  article__image">
                        <Youtube link={"https://www.youtube.com/embed/0t04wSxOXT4"}/>
                      </div>

                    </div>
                  </div>
                </div>
              </section>
            </Observer>

            <Observer {...options}>
              <section className="longread" ref={this.section7ref} data-id="7">
                <div className="longread__section">
                  <div className="article">
                    <h2 className="article__subtitle">Вы — тоже <br className="--mobile" />гонщик!</h2>
                    <div className="article__row">
                      <div className="article__col article__text">
                        <p>Автоспорт всегда являлся основным вектором развития Porsche, а опыт полученный на гоночных трассах неизменно находит своё отражение в дорожных машинах. И вместе с Porsche стать частью автоспорта может каждый. По всему миру действуют Центры вождения Porsche, а в 2015 году проект Porsche Experience появился и в России.</p>

                        <p>Профессиональные инструкторы <a onClick={() => this.sendLinkevent()} href="https://porsche-russland.ru/pdc/?utm_source=Championat&utm_medium=SP&utm_campaign=Special_Project" target="_blank" rel="noopener noreferrer">Porsche Experience Center Russia</a> разработали для энтузиастов автоспорта и быстрой езды <span className="--mobile">различные программы — в зависимости от имеющихся навыков водителя. Пилотаж на гоночной трассе, контролируемый дрифт, секреты идеального прохождения поворотов и наиболее эффективного торможения и даже зимние заезды по ледяной трассе. Овладеть этими навыками — мечта каждого поклонника скорости, и с Porsche она становится реальностью. Вместе с этим уже шесть лет в России проходит чемпионат <a onClick={() => this.sendLinkevent()} href="https://porsche-russland.ru/pdc/club/?utm_source=Championat&utm_medium=SP&utm_campaign=Special_Project" target="_blank" rel="noopener noreferrer">Porsche Sport Challenge</a> — закрытое клубное первенство для владельцев Porsche.</span></p>
                      </div>
                      <div className="article__col article__text --desktop">
                        <p>
                          различные программы — в зависимости от имеющихся навыков водителя. Пилотаж на гоночной трассе, контролируемый дрифт, секреты идеального прохождения поворотов и наиболее эффективного торможения и даже зимние заезды по ледяной трассе. Овладеть этими навыками — мечта каждого поклонника скорости, и с Porsche она становится реальностью. Вместе с этим уже шесть лет в России проходит чемпионат <a onClick={() => this.sendLinkevent()} href="https://porsche-russland.ru/pdc/club/?utm_source=Championat&utm_medium=SP&utm_campaign=Special_Project" target="_blank" rel="noopener noreferrer">Porsche Sport Challenge</a> — закрытое клубное первенство для владельцев Porsche.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="longread__image">
                    <Fade {...fadeOptions}>
                      <img src="/images/long4.jpg" alt="porsche" className="longread__fullwidth" />
                    </Fade>
                    <div className="article__col --on-picture  article__text">В рамках Porsche Sport Challenge проходят три типа состязаний — 30-минутная гонка, заезды на скорость на одном круге и соревнования на стабильное время прохождения кругов на таких трассах, как Moscow Raceway, “Нижегородское кольцо” и KazanRing. Вы ведь помните, что Porsche — это гонки?</div>
                  </div>

                </div>
              </section>
            </Observer>

            <Observer {...options}>
              <section className="longread" ref={this.section8ref} data-id="8">
                <div className="longread__section">
                  <div className="article">
                    <h2 className="article__subtitle">Ещё ближе <br className="--mobile" />к Porsche!</h2>
                    <div className="article__row">
                      <div className="article__col article__text">
                        <p>С 8 по 10 июня 2018 года в честь 70-летия выпуска первого автомобиля Porsche по всему миру одновременно прошёл грандиозный автоспортивный фестиваль — Sportscar Together Day. Например, в Москве владельцев Porsche и поклонников марки ждала уникальная экспозиция коллекционных автомобилей и раритетов, культовые модели Porsche, возможность проехаться по треку на Porsche 911, а также российская премьера нового Porsche Cayenne.</p>
                      </div>
                      <div className="article__col article__text">
                        <p className="--last">
                          Всего в России мероприятия Sportscar Together Day были запланированы сразу в 16 городах — ознакомиться с полным списком можно на официальном сайте Porsche.
                        </p>
                        <p className="--desktop">
                          Грандиозный праздник с участием клиентов, энтузиастов и фанатов спортивных автомобилей позволил прикоснуться к самым удивительным машинам в истории Porsche. Разделяйте страсть к скорости с теми, кто её создаёт!
                        </p>
                      </div>
                    </div>

                    <Fade {...fadeOptions}>
                      <Slider/>
                    </Fade>

                    <div className="article__row --mobile">
                      <div className="article__col article__text">
                        <p>
                          Грандиозный праздник с участием клиентов, энтузиастов и фанатов спортивных автомобилей позволил прикоснуться к самым удивительным машинам в истории Porsche. Разделяйте страсть к скорости с теми, кто её создаёт!
                        </p>
                      </div>
                    </div>
                    <div className="link__container">
                      <button className={"link--next"} onClick={() => {this.scrollToSection(9); sendEvent('main', 'click', 'arrow');}} >
                        <span>Гоночный сезон 2018</span>
                      </button>
                    </div>
                  </div>

                </div>
              </section>
            </Observer>

          </ScrollPercentage>

          <ScrollPercentage category={"interview1"} type={"short"}>
            <section className="longread" >
              <Observer {...optionsInterview}  >
                <div className="longread__section" ref={this.section9ref} data-id="9"  data-scroll="true">
                  <img src="/images/interview1.jpg" alt="porsche" className="longread__fullwidth" />
                  <div className="interview__quote">
                    Гонки Porsche помогают направить жизнь<br/>
                    в правильное русло
                  </div>
                </div>
              </Observer>
              <div className="longread__section">
                <div className="article">
                  <h1 className="article__title">Светлана Горбунова</h1>

                  <div className="article__row">
                    <div className="article__col article__text">
                      <p>Светлана Горбунова — одна из самых известных участниц российских клубных гонок. Увлечение гонками в качестве болельщицы и желание овладеть автомобилем привели Светлану на программы <a onClick={() => this.sendLinkevent()} href="https://porsche-russland.ru/pdc/" target="_blank" rel="noopener noreferrer" >«Porsche Experience» Центра вождения Порше</a>, которые превратили девушку в настоящую пилотессу — теперь она регулярно выступает на соревнованиях и может изнутри рассказать, как устроен автоспорт.</p>
                      <p>Зачем обычному человеку уметь водить быстрые машины и как участие в гонках влияет на повседневную жизнь? Слово Светлане Горбуновой.</p>
                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview2.jpg" alt=""/>
                    </div>
                  </div>

                  <div className="article__row">
                    <div className="article__col article__text">
                      <p className="p_question">Как вам вообще пришла идея пойти на программы Porsche Experience?</p>
                      <p>Это пришло с приобретением автомобиля. Папа купил себе быстрый спортивный автомобиль и первым поехал на тренинг с коллегами. Он остался в полном восторге, а когда подарил машину мне, то сказал, что сначала надо научиться на ней ездить. А так — мне всегда нравилось. Я была и являюсь фанатом MotoGP, мотоциклов, моторов, скорости. Мне нравилась Формула-1, регулярно посматривала гоночки. И было интересно узнать, как это всё работает, оказаться внутри. Когда я только села и попробовала, то поняла: это то, что я всю жизнь хотела и искала.</p>

                      <p className="p_question">Вы участвовали в программах Porsche Experience более 65 раз. Помните свои ощущения от самого первого посещения?</p>
                      <p>Получилось так, что в тот день зарегистрировалась только я одна. И ребята полный день со мной откатали, подробно мне всё рассказали и уделили очень много внимания. Это и стало толчком. Когда я села в машину, то поняла, что хочу её водить хорошо и быстро. Это переросло в хобби, и теперь оно занимает очень много моего времени. Эти программы, само знакомство с автомобилем - очень затягивающая вещь. Я с нетерпением ждала каждого следующего тренинга.</p>

                      <p className="p_question">Участники программ после них получают шанс выступить в состязаниях «Porsche Sport Challenge». То есть вы можете не просто научиться быстро ездить по гоночной трассе, но и тут же продемонстрировать собственные навыки в реальном состязании. Можете рассказать об этом подробнее?</p>
                      <p>В рамках Porsche Sport Challenge проходит три вида соревнований – общая гонка на 30 минут, Time Attack – состязания на время на одном круге, а также соревнования на стабильное время прохождения кругов.</p>
                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview3.jpg" alt=""/>
                    </div>
                  </div>

                  <div className="article__row one-col">
                    <div className="article__col article__text">
                      <p>После неоднократного прохождения программы Master на Porsche GT3 мне пришла идея покупки этого автомобиля. Те машины, которые уже находились у меня в гараже, были для души, для радости, каких-то своих амбиций. А вот эта модель, появившаяся у меня в конце августа 2017 года, стала осознанной покупкой именно для участия в чемпионате.</p>
                      <p>В прошлом году автомобиль ко мне пришёл под конец сезона, и я почти прямиком от дилера приехала на трек – туда, где эта машина и должна быть (смеётся). Я проехала один этап Porsche Sport Challenge – это был Time Attack. Познакомила автомобиль с трассой, познакомилась сама с автомобилем, вкатилась. А уже в этом году Олег Кесельман предложил принять участие в очной гонке, и я согласилась. Общая гонка – 30-минутная очная борьба с общим стартом, который у нас дается с хода. Это своего рода борьба с самим собой – на этот старт надо выйти!</p>
                    </div>
                  </div>

                  <div className="article__row">
                    <div className="article__text article__col">
                      <p className="p_question">Перед первым заездом было страшно?</p>
                      <p>Мандраж бывает. У кого-то он наступает в совсем ненужный момент, может возникнуть даже в самой гонке. У некоторых волнение проходит, когда гаснет светофор. У меня мандраж тоже был – первая гонка, многие нюансы мне были неизвестны… Тогда ещё ребята бегали по боксам и таскали канистру, чтобы заправить машину. Остальные участники уже стоят на стартовой решётке, а я всё ещё в боксах с незаправленной машиной! А тут ещё подошёл один из организаторов чемпионата и стал объяснять, как будет проходить старт с хода – для меня это тоже было в новинку. Так что волнение, безусловно, присутствовало.</p>
                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview4.jpg" alt=""/>
                    </div>
                  </div>

                  <div className="article__row one-col">
                    <div className="article__col article__text">
                      <p>Но когда проехали прогревочный круг и стартовали, все мысли уже были только о гонке — о трассе, поворотах. Пошла своего рода медитация. Я просто собралась и поехала, как учили.</p>
                    </div>
                  </div>
                </div>

                <div className="longread__image">
                  <img src="/images/interview5.jpg" alt="porsche" className="longread__fullwidth" />
                </div>

                <div className="article">
                  <div className="article__row one-col">
                    <div className="article__col article__text">
                      <p className="p_question">Гонки для вас — это прежде всего борьба или скорее та самая медитация, чувство единения с машиной?</p>
                      <p>Конечно, борьба. Я думаю, все выезжают выигрывать. Как говорят, второй – это первый среди проигравших. Смысл всё-таки в борьбе, ведь это гонки, а не крестный ход. Есть соревнования на время, и там ты соревнуешься сам с собой, с секундомером и с трассой. Ты и машина – одно целое, и это немного другой настрой. А когда выезжаешь на гонку, то борьба за первое место.</p>
                    </div>
                  </div>
                  <div className="article__row">
                    <div className="article__col article__text">
                      <p className="p_question">Увлечение гонками требует много сил и времени. Не мешает ли это другим делам?</p>
                      <p>Времени хватает. Я бы даже сказала, что участие в чемпионате и борьба за время переносятся и на повседневную жизнь. Гонки помогают сосредоточиться и не тратить время на то, что тебе не интересно или не нужно, помогают направить жизнь в правильное русло. В повседневной жизни идёт борьба со временем — так же, как и на трассе.</p>

                      <p className="p_question">Если водитель не хочет участвовать в гонках и никогда ими не интересовался, вы бы все равно посоветовали ему принять участие в программах?</p>
                      <p>Конечно, это будет очень полезно! Во-первых, это даёт понимание автомобиля, его поведения — и поведения самого себя за рулём. Тренировки очень дисциплинируют. На дороге среднестатистический водитель часто полагается на машину, но не рассчитывает собственные силы. Слава богу, машины сейчас все умные и оснащены электроникой, но иногда что-то может пойти не так и, к сожалению, случаются трагедии с непоправимыми последствиями. А эти программы готовят человека не только ехать быстро, но и ехать безопасно – для себя и окружающих. Тем более, на мощных автомобилях.</p>
                      <p>А вообще всё это помогает развивать реакцию, понимать, что происходит на дорогах. Ты можешь предотвратить ситуацию, которую без серьёзных навыков избежать не смог бы. Раньше мама говорила, что боится со мной ездить на пассажирском сидении: — мол, дорога, на ней много дураков, произойти может что угодно. А теперь мы садимся в машину, и она там спокойно отдыхает! Потому что я сама спокойна.</p>

                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview6.jpg" alt=""/>
                    </div>
                  </div>

                  <div className="article__row one-col">
                    <div className="article__col article__text">
                      <p className="p_question">Вы были одним из участников фестиваля Sportscar Together Day, посвящённого 70-летию выпуска первого автомобиля Porsche. Как всё прошло?</p>
                      <p>Это было потрясающее мероприятие! Начиная с организации и заканчивая тем, что собирались единомышленники и зрители – как одна большая семья. Porsche каким-то образом удаётся проводить такие фестивали очень душевно. Многие прикатили туда свои машины, событие было по-настоящему грандиозным!</p>
                    </div>
                  </div>
                </div>


                <div className="longread__image">
                  <img src="/images/interview7.jpg" alt="porsche" className="longread__fullwidth" />
                </div>
                <Observer {...options} >
                  <div className="article" data-id="9">
                    <div className="article__row one-col">
                      <div className="article__col article__text">
                        <p className="p_question">Напоследок давайте поговорим о других гонках. Вы говорили, что следите за Формулой-1. Болеете за кого-нибудь?</p>
                        <p>Регулярно смотреть гонки не получается: наши мероприятия часто пересекаются с другими гонками. Но я всегда болею за борьбу, за интересные моменты в гонке. Все пилоты Формулы-1 талантливы, это 20 самых быстрых пилотов в мире. И дальше всё уже зависит от того, как кто себя проявляет. Чья команда справилась на том или ином этапе лучше, тот и молодец.</p>

                        <p className="p_question">Как думаете, кто в этом сезоне справится лучше – Хэмилтон или Феттель?</p>

                        <p>В этом сезоне я скорее за Феттеля. Так что делаем ставки на Ferrari (смеётся).</p>

                        <p className="p_question">Валентино Росси ещё станет чемпионом MotoGP?</p>
                        <p>Должен стать! Ну должен! Я верю в его победу (смеётся).</p>
                      </div>
                    </div>
                    <div className="link__container">
                      <button className={"link--next"} onClick={() => {
                        this.scrollToSection(10);
                        sendEvent('main', 'click', 'arrow')
                      }}>
                        <span>Интервью с Олегом Кесельманом</span>
                      </button>
                    </div>

                  </div>
                </Observer>
              </div>
            </section>
          </ScrollPercentage>

          <ScrollPercentage category={"interview2"} type={"short"}>
            <section className="longread">
              <Observer {...options}  >
                <div className="longread__section interview__section" ref={this.section10ref} data-id="10" data-scroll="true">
                  <img src="/images/interview2_1.jpg" alt="porsche" className="longread__fullwidth"/>
                  <div className="interview__quote --second">
                    раз уж ты потратил <br/>большие деньги <br/>на такую машину, <br/>глупо её бояться!
                  </div>
                </div>
              </Observer>
              <div className="longread__section">
                <div className="article">
                  <h1 className="article__title">Олег Кесельман</h1>

                  <div className="article__row">
                    <div className="article__col article__text">
                      <p>В 2007 году в России появился российский клуб владельцев Porsche, созданный при поддержке дочернего общества Porsche AG – ООО «Порше Руссланд». Это, в первую очередь, клуб единомышленников и поклонников немецкой марки. При участии его представителей ООО «Порше Руссланд» за последние годы создало программы спортивного вождения Porsche Experience, клубные первенства в рамках Porsche Motorsport Day, которые проходят на гоночных трассах международных категорий, и мероприятия для поклонников и энтузиастов марки.</p>
                      <p>Чтобы узнать подробнее о том, что такое Porsche Experience, мы пообщались с Олегом Кесельманом - - руководителем российского Порше Клуба и шеф-инструктором <a  onClick={() => this.sendLinkevent()} href="https://porsche-russland.ru/pdc/" target="_blank" rel="noopener noreferrer">Центра вождения Порше</a>.</p>
                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview2_2.jpg" alt=""/>
                    </div>
                  </div>

                  <div className="article__row">
                    <div className="article__col article__text">
                      <p className="p_question">— Олег, расскажите подробнее о Porsche Experience. Для чего был создан этот проект?</p>
                      <p>Porsche Experience - это серия программ спортивного вождения, мы предоставляем возможность попробовать автомобили Porsche в условиях трека под руководством инструкторов по специально разработанным программам. У вас есть автомобиль, но вы опасаетесь выезжать на трек на своём автомобиле? Вы прошли дилерский тест-драйв, но ещё не составили своего мнения и надо поездить ещё - побыстрее и безопасно? Вот как раз Porsche Experience предоставляет такую возможность.</p>
                      <p className="p_question">— Какие люди приходят в программу и с чем они столкнутся в <a  onClick={() => this.sendLinkevent()} href="https://porsche-russland.ru/pdc/" target="_blank" rel="noopener noreferrer">Центре вождения Порше</a>?</p>
                      <p>Люди приходят очень разные. Существуют четыре программы. Первая из них - Introduction, она более массовая. Сюда приходят владельцы автомобилей Porsche, при покупке которых вручается сертификат. Их получают владельцы и 911-й модели, и Boxster, и Macan, а это очень разные машины и по характеру, и по целевой аудитории. Таким образом, публика получается очень разношёрстная, хотя всё это лояльные Porsche люди. Приходя к нам в первый раз, они поначалу не совсем знают, куда попали, и поэтому у нас к ним особое отношение.</p>
                      <p>К нам приходят не только те, кто хочет погонять на треке. Например, человек купил дорогой, быстрый и мощный автомобиль и хочет им овладеть. Не для того, чтобы гонять на дорогах, а чтобы понимать его. Всё-таки автомобили Porsche покупают перфекционисты. И раз уж ты потратил большие деньги на такую машину, глупо её бояться. И большинство приходят как раз именно за этим, чтобы быть с автомобилем на ты.</p>

                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview2_3.jpg" alt=""/>
                    </div>

                  </div>

                  <div className="article__row one-col">
                    <div className="article__col article__text">
                      <p>В Porsche Experience Center мы продаём эмоции, и мы заточены под эмоции. И с помощью учебных программ и гонок мы как раз и даём возможность испытать эти эмоции в правильных условиях, преподносим их под нужным соусом. И здесь каждый придумывает себе легенду — зачем ему нужен этот автомобиль. У каждого здесь своя история, и подогнать публику под какой-то один общий знаменатель просто невозможно.</p>
                    </div>
                  </div>

                  <div className="article__row">
                    <div className="article__col article__text">
                      <p className="p_question">— Что происходит после Introduction?</p>
                      <p>Далее идут три другие программы - Precision, Performance и Master. Там уже немного другая публика. Во-первых, за эти программы клиенты платят деньги, а во-вторых - они уже знают, куда попали, и хотят научиться. И у них самих уже немного другое отношение к процессу. Да и наша ответственность здесь совсем другая, ведь если человек заплатил деньги, а мы не оправдали его надежд на обучение, то он к нам никогда не вернётся. А у нас очень много людей, которые после прохождения одного курса идут на следующий, потом - на следующий, и благодаря этому повторные продажи занимают у нас довольно большой сегмент.</p>
                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview2_4.jpg" alt=""/>
                    </div>
                  </div>

                  <div className="article__row one-col">
                    <div className="article__col article__text">
                      <p>Таким образом, мы даём возможность попробовать спортивные автомобили уже на курсе Introduction, а на трёх последующих курсах уже должны удовлетворить потребности в обучении. Это уже больше педагогика, преподавание спортивного вождения, и здесь уже необходимо выкладываться в том числе в психологическом плане.</p>
                    </div>
                  </div>

                </div>

                <div className="longread__image">
                  <img src="/images/interview2_5.jpg" alt="porsche" className="longread__fullwidth"/>
                </div>

                <div className="article">
                  <div className="article__row one-col">
                    <div className="article__col article__text">
                      <p className="p_question">- Как, на ваш взгляд, меняются люди после прохождения этих программ?</p>
                      <p>Как правило люди перестают гонять на дорогах. Можно сказать, они устают, выкладываются на трассе, и желания гонять на дорогах общего пользования уже нет. Они выпускают пар на трассе, получают эмоции и понимают, что глупо ездить по дорогам так, как ты едешь на треке. Даже молодые люди приходят и рассказывают: мол, к вам ехали, неслись, а уезжали уже понимая, что нет в этом никакого смысла.</p>
                    </div>
                  </div>
                  <div className="article__row">
                    <div className="article__col article__text">
                      <p className="p_question">Увлечение гонками требует много сил и времени. Не мешает ли это другим
                        делам?</p>
                      <p>Обладание автомобилем Porsche меняет жизнь, это сто процентов. Конечно, я со всеми общаюсь, и вы просто не представляете, какое впечатление порой производят на людей наши программы. Один участник хотел себе 911-й, но сел за руль Cayman и говорит, что вот только теперь понял, какой автомобиль ему нужен. А на следующий день произошло ровно наоборот: человек хотел себе Cayman, но попробовал 911-й и выбрал его.</p>
                      <p>
                        Так что невозможно рассказать, как меняется жизнь людей, у каждого это происходит по-своему. Даже в примере выше - абсолютно разные реакции, притом оба человека прежде никогда не гоняли на треке, никогда не ездили на спорткарах. Всё очень по-разному.</p>

                      <p className="p_question">— Лично вы какой автомобиль выбрали бы для того, чтобы проехать, например по Moscow Raceway?</p>
                      <p>911 GT2 или GT3… GT2, наверное… Да, думаю, всё-таки GT2.</p>

                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview2_6.jpg" alt=""/>
                    </div>
                  </div>

                  <div className="article__row one-col">
                    <div className="article__col article__text">
                      <p className="p_question">— Что происходит после прохождения Porsche Experience? Например, человек прошёл все четыре программы и хочет продолжать...</p>
                      <p>После программ некоторые идут дальше. Скажем так, заражаются этой бациллой духа Porsche: ты купил автомобиль, на котором можешь ездить каждый день на работу, а в выходные приехать на трек и посоревноваться вместе с единомышленниками. А в понедельник на нём же снова поехать на работу. </p>
                    </div>
                  </div>
                </div>
                <Observer {...options}>
                <div className="longread__image" data-id="10" >
                  <img src="/images/interview2_7.jpg" alt="porsche" className="longread__fullwidth"/>
                </div>
                </Observer>
                  <div className="article" >
                    <div className="article__row one-col">
                      <div className="article__col article__text">
                        <p>Это уникальная особенность, и как раз для таких мы организовываем чемпионат под названием Porsche Sport Challenge. Мы проводим мероприятия Porsche Motorsport Day, в рамках которого проходят различные заезды, чтобы каждый мог найти себе подходящего по уровню соперника. То есть если у тебя автомобиль GT3 или GT2, то ты соревнуешься с такими же, а если у тебя Boxster, то можешь выбрать другое соревнование. Или можно просто приехать пообщаться с единомышленниками, посмотреть. Таких мероприятий мы проводим шесть в году на разных гоночных трассах. Присоединяйтесь!</p>
                      </div>
                    </div>
                    <div className="link__container">
                      <button className={"link--next"} onClick={() => {
                        this.scrollToSection(11);
                        sendEvent('main', 'click', 'arrow')
                      }}>
                        <span>Moscow Raceway</span>
                      </button>
                    </div>
                  </div>


              </div>

            </section>
          </ScrollPercentage>

          <ScrollPercentage category={"interview3"} type={"short"}>
            <section className="longread">
              <Observer {...options}  >
                <div className="longread__section interview__section" ref={this.section11ref} data-id="11" data-scroll="true">
                  <img src="/images/interview_3_1.jpg" alt="porsche" className="longread__fullwidth"/>
                  <div className="interview__quote">
                    Porsche Experience: как промчать <br />по Moscow Raceway и стать <br />примером для остальных
                  </div>
                </div>
              </Observer>
              <div className="longread__section">
                <div className="article">
                  <h1 className="article__title">Moscow Raceway</h1>

                  <div className="article__row">
                    <div className="article__col article__text">
                      <p><b>Инструкторы <a href={instructors} className="link--red" target="_blank">программ</a> <a href={instructors} className="link--red" target="_blank">спортивного</a> <a href={instructors} className="link--red" target="_blank">вождения</a> <a href={instructors} className="link--red" target="_blank">Porsche</a> <a href={instructors} className="link--red" target="_blank">Experience</a> о том, как проехать по Moscow Raceway (и не только) и не попасть впросак.</b></p>
                      <p>История Porsche тесно переплетена со спортом и страстью к достижению новых пределов. И часть этой страсти есть в каждом Porsche, когда-либо сходившим с конвейера. Но где реализовать эту страсть и узнать, на что эта машина способна по-настоящему? Конечно, на гоночной трассе.</p>
                      <p>Для этого мы отправились на Moscow Raceway к инструкторам Porsche Experience, чтобы понять, как укротить сотни лошадиных сил в пределах гоночной трассы.</p>
                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview_3_2.jpg" alt=""/>
                    </div>
                  </div>

                  <div className="article__row">
                    <div className="article__col article__text">
                      <p>Porsche Experience насчитывает четыре программы обучения — от вступительной части <b><a href={introduction} className="link--red" target="_blank">«Introduction»</a></b> до более сложных  <b><a href={precision} className="link--red" target="_blank">«Precision»</a></b>, <b><a href={performance} className="link--red" target="_blank">«Performance»</a></b> и <b><a href={master} className="link--red" target="_blank">«Master»</a></b>.</p>
                    </div>
                    <div className="article__col article__text">
                      <p>В первой программе заезды проходят по самой короткой версии трассы — «Суперспринт» (длиной 1357 м.), а также по версии «Гран-при» (3955 м.). В последующих программах используется версия «Спринт» — 2661 м.</p>
                    </div>
                  </div>
                </div>
                <div className="longread__map">
                  <div className="map__title --top">Версия «Суперспринт»</div>
                  <img src="/images/interview_3_map.png" alt="porsche" className="longread__fullwidth" />
                  <div className="map__title --bottom">Версия «Спринт»</div>
                </div>
                <div className="article">
                  <div className="article__row article--top50">
                    <div className="article__col article__text">
                      <p>Прежде чем выехать на трассу, участников программы ждёт обязательный брифинг, на котором старший инструктор объясняет суть предстоящих занятий. Здесь аудитория знакомится с автомобилями, на которых им предстоит ездить: на пит-лейне их ждёт дюжина самых разных машин — от большого Cayenne S до 911 Carrera 4S с приводом на обе оси. Вместе с этим, инструктор даёт теоретическую базу: объясняет физику торможения автомобиля на трассе, нюансы прохождения поворотов, особенности развесовки представленных машин и множество других тонкостей, которые пригодятся на гоночном полотне.</p>
                    </div>
                  </div>
                </div>

                <div className="longread__image">
                  <img src="/images/interview_3_3.jpg" alt="porsche" className="longread__fullwidth"/>
                </div>

                <div className="article">
                  <div className="article__row">
                    <div className="article__col article__text">
                      <p>Кроме того, на брифинге инструктор объясняет участникам предстоящие упражнения и даёт советы. Так, например, в «змейке» — традиционном проезде между выстроенными в линию конусами — инструкторы советуют меньше крутить руль, чтобы успеть выровнять его. Чем меньше лишних движений — тем выше скорость.</p>
                      <p>Упражнение на технику — прохождение поворота — требует большей концентрации. К началу упражнения здесь отмечены все ключевые точки: момент начала торможения, точка начала поворота, апекс и момент разгона.</p>
                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview_3_4.jpg" alt=""/>
                    </div>
                  </div>
                  <div className="article__row">
                    <div className="article__col article__image">
                      <img src="/images/interview_3_5.jpg" alt=""/>
                    </div>
                    <div className="article__col article__text">
                      <p>«Змейка» среди конусов кажется одним из самых банальных упражнений, однако в Porsche Experience есть нюанс: здесь инструкторы просят исполнить его на максимально возможной скорости. Здесь важно работать рулём быстро, но не резко, а сам поворот руля должен быть минимальным — так автомобиль едет ровнее, происходит меньшее перераспределение центра тяжести, а сцепление получается наиболее ровным и стабильным. Это упражнение как никакое другое позволяет прочувствовать автомобиль в динамике, понять его повадки и особенности. Так, «нос» заднеприводного 911-го будет стараться смотреть наружу — центр тяжести смещён назад, поэтому передняя ось остаётся недогруженной.</p>
                    </div>
                  </div>
                  <div className="article__row">
                    <div className="article__col article__text">
                      <p>Следующее упражнение, несмотря на кажущуюся лёгкость, для многих представляет серьёзную трудность: разгон с места и экстренное торможение. Porsche 911 Turbo S разгоняется до сотни за 2,9 секунды — найти условия для такого ускорения в городе сложно, зато на Moscow Raceway старт можно отработать до совершенства. Достичь такого ускорения на 911 Turbo S не сложно – сложно удержать автомобиль под контролем и правильно погасить скорость.</p>
                      <p>На автомобилях Porsche есть система PCCB — Porsche Ceramic Composite Brake. Керамическая тормозная система мгновенно «ловит» машину и позволяет за доли секунды остановить автомобиль.</p>
                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview_3_6.jpg" alt=""/>
                    </div>
                  </div>
                  <div className="article__row one-col">
                    <div className="article__col article__text">
                      <p>Новичкам, правда, такие приёмы удаются не всегда — при экстремальном торможении АБС «выдавливает» тормоз обратно, а потому инструкторы часто подбадривают пришедших: «Не бойтесь изо всех сил давить на тормоз. Машине не больно». Впрочем, с первого раза затормозить в нужной точке мало у кого получается — все начинают работать тормозом чуть раньше.</p>
                    </div>
                  </div>
                </div>

                <div className="longread__image">
                  <img src="/images/interview_3_7.jpg" alt="porsche" className="longread__fullwidth"/>
                </div>
                <div className="article">
                  <div className="article__row">
                    <div className="article__col article__text">
                      <p>Упражнение, следующее далее — прохождение поворота — позволит суммировать полученные ранее навыки, чтобы затем со знанием дела выйти на трассу. Сначала участники проезжают поворот на низкой скорости — вслед за автомобилем инструктора, чтобы затем повторить его траекторию. По ходу тестового проезда инструктор также объясняет расположение точек торможения, апекса и момент, при котором лучше всего открывать газ на выходе.</p>
                      <p>Частые ошибки здесь: слишком раннее торможение, которое не позволяет проехать поворот на максимальной скорости, или же чересчур ранний выход на газ — передняя ось разгружается, колёса теряют сцепление, а автомобиль тащит на внешнюю обочину. Впрочем, все ошибки в «реальном времени» корректирует инструктор, находящийся внутри поворота с рацией.</p>
                    </div>
                    <div className="article__col article__image">
                      <img src="/images/interview_3_8.jpg" alt=""/>
                    </div>
                  </div>
                  <div className="article__row">
                    <div className="article__col article__image">
                      <img src="/images/interview_3_9.jpg" alt=""/>
                    </div>
                    <div className="article__col article__text">
                      <p>В итоге после нескольких проездов даже новички начинают чувствовать себя за рулём спорткара намного увереннее.</p>
                      <p>И наконец финальное упражнение — проезд по трассе. В программе Introduction используется короткое кольцо «Суперспринт», включающее в себя заключительную часть полной конфигурации Moscow Raceway, в остальных программах заезды проходят по другой части трассы — с перепадами высот и более жёсткими торможениями. Впрочем, почувствовать мощь нескольких сотен «лошадей» можно и на «Суперспринте», включающем в себя как резкую связку 7-9 поворотов, так и затяжные 12-й, 13-й и <span className={"nowrap"}>14-й</span>.</p>
                    </div>
                  </div>
                  <Observer {...options}>
                    <div className="article__row one-col" data-id="11">
                      <div className="article__col article__text">
                        <p>Заезд продуман предельно безопасно: автомобили двигаются колонной вслед за инструктором, который контролирует темп участников и даёт подсказки по рации.</p>
                        <p>Впрочем, к этому моменту возможности Porsche становятся понятны, после отработки упражнений каждый чувствует себя на трассе вполне уверенно и уже после двух-трёх кругов поднимают темп до такого уровня, что перегрузки на разгонах и в поворотах перестают быть теоретическими.</p>
                        <p><b>И только так — с перегрузками и внимательным изучением теории — можно стать с Porsche единым целым — совершенным симбиозом машины и человека, для которого нет непреодолимых преград.</b></p>
                      </div>
                    </div>
                  </Observer>
                  <div className="link__container">
                    <button className={"link--next"} onClick={() => {
                      this.scrollToSection(12);
                      sendEvent('main', 'click', 'arrow')
                    }}>
                      <span>конкурс «на скоростях»</span>
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </ScrollPercentage>


          <Observer {...options}>
            <section className="longread" ref={this.section12ref} data-id="12" data-scroll="true">
              <CookiesProvider>
                <Test />
              </CookiesProvider>

              <div className="link__container test__arrow">
                <button className={"link--next link--test"} >
                </button>
              </div>

            </section>
          </Observer>

          <Observer {...options}>
            <section className="longread" ref={this.section13ref} data-id="13" data-scroll="true">
              <InfoGraphic />
            </section>
          </Observer>

        </Scroll>
      </div>
    )
  }
}

Home.propTypes = {
  currentItem: PropTypes.number,
  scroll: PropTypes.bool,
  isOpen: PropTypes.bool
}

const mapDispatchToProps = (dispatch) => {
  return {
    onScrollInViewport: (id, scroll = false) => {
      dispatch(selectItem(id, scroll))
    }
  }
}

const mapStateToProps = state => {
  const {menu} = state
  return {
    ...menu
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home))


// WEBPACK FOOTER //
// ./src/pages/home/home.js